import moment from 'moment'
import React, { useState } from 'react'
import { DatePicker, Dropdown, Menu } from 'antd'
import { useSelector } from 'react-redux'
import { Route, Switch, useHistory, Link } from 'react-router-dom'

import { AiOutlineDown } from 'react-icons/ai'

import { useToggle, stringifyDate, useListData } from '../../modules'

import Receive from '../../components/reusable/receive'

import MergeSuppliers from '../../components/drawers/mergeSuppliers'
import NewSupplier from '../../components/drawers/newSupplier'
import Supplier from '../../components/drawers/supplier'

const { RangePicker } = DatePicker

const Suppliers = () => {
    const [ranges, setRanges] = useState()
    const [selected, setSelected] = useState(null)
    const [string, setString] = useState('')
    const [token, setToken] = useState()
    const [chosen, setChosen] = useState([])

    const history = useHistory()

    const [merge, toggleMerge] = useToggle()
    const [select, toggleSelect] = useToggle()

    const { user } = useSelector(state => state.application)

    const [
        { loading, error, fetch },
        { list: suppliers },
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('suppliers', ranges ?
        { string, from: ranges[0]?._d ?? null, to: ranges[1]?._d ?? null }
        : { string }
        , { notify: true, manual: false })
    
    const refetch = () => {
        fetch()
        navigate(1)
    }

    const choose = id => {
        let temp = [...chosen]

        if (temp.includes(id)) {
            temp = temp.filter(x => x !== id)
        } else {
            temp.push(id)
        }

        setChosen(temp)
    }

    const togSelect = () => {
        setChosen([])
        toggleSelect()
    }

    const removeSupplier = i => setChosen(supp => supp.filter(((_, k) => k !== i)))

    const selectRange = range => {
        setRanges(range)
        refetch()
    }

    const search = str => {
        setString(str)
        if (str?.trim().length > 2 || str.length === 0)
            refetch()
    }
    
    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            <div className="flex justify-between items-center mt-1 mb-5">
                <input
                    onChange={e => search(e.target.value)}
                    className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-inv-item"
                    type="text"
                    placeholder="Search For Supplier" />
                {
                    merge &&
                    <MergeSuppliers
                        onPerform={ () => {
                            fetch()
                            setChosen([])
                        } }
                        removeSupplier={ removeSupplier }
                        selected={ chosen }
                        toggle={ toggleMerge }
                        visible={ merge } />
                }
                <span className="flex items-center">
                    <RangePicker
                        onChange={selectRange}
                        ranges={{
                            'Today': [moment().startOf('day'), moment().endOf('day')],
                            'Yesterday': [moment().subtract(1, 'day').startOf('day'), moment().subtract(1, 'day').endOf('day')],
                            'This Week': [moment().startOf('week'), moment().endOf('week')],
                            'This Month': [moment().startOf('month'), moment().endOf('month')],
                        }}/>
                        {
                            user.issuperuser ?
                                <Dropdown
                                    overlay={
                                        <Menu>
                                            <Menu.Item onClick={togSelect}>{ select ? 'Deselect All' : 'Select' }</Menu.Item>
                                            {
                                                chosen.length > 1 ? <Menu.Item onClick={ toggleMerge }>Merge {chosen.length} Suppliers</Menu.Item> : null
                                            }
                                            <Link to="/app/accounts/purchases/suppliers/new">
                                                <Menu.Item>New Supplier</Menu.Item>
                                            </Link>
                                        </Menu>
                                    }>
                                    <button className="btn hisani-btn-green-light ml-2 text-white">
                                        <span className="hidden xs:block mr-2">Actions { chosen.length > 0 ? `(${chosen.length})` : '' }</span>
                                        <AiOutlineDown />
                                    </button>
                                </Dropdown>
                            :
                                <Link to="/app/accounts/purchases/suppliers/new">
                                    <button className="btn ml-2 py-2.5 hisani-btn-green-light text-white">New Supplier</button>
                                </Link>
                        }
                </span>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <h2 className="font-semibold text-gray-800">Suppliers</h2>
                </header>
                <Receive
                    error={error}
                    loading={loading}
                    progress>
                    {
                        suppliers.length > 0 ?
                            <table className="table-auto w-full">
                                {/* Table header */}
                                <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                    <tr>
                                        <th className="p-2">
                                            <div className="font-semibold text-center">{select ? 'Selected' : 'No'}</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-left">Name</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-left">Contact Person</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-center">Phone</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-center">Email</div>
                                        </th>
                                        <th className="p-2">
                                            <div className="font-semibold text-center"></div>
                                        </th>
                                    </tr>
                                </thead>
                                {/* Table body */}
                                <tbody className="text-sm font-medium divide-y divide-gray-100">
                                    {
                                        suppliers.map((supplier, key) =>
                                            <tr>
                                                <td className="p-2">
                                                    <div className="text-center">
                                                        {
                                                            select ?
                                                                <input
                                                                    onChange={ () => choose(supplier) }
                                                                    checked={ chosen.some(supp => supp._id === supplier._id) }
                                                                    type="checkbox"
                                                                    className="form-checkbox cursor-pointer h-5 w-5" />
                                                            : `${((page - 1) * limit) + (key + 1)}.`
                                                        }
                                                    </div>
                                                </td>
                                                <td className="p-2">
                                                    <div className="">{supplier?.name}</div>
                                                    <p className="mb-0 text-gray-400 text-xs italic">{ stringifyDate(supplier.date) }</p>
                                                </td>
                                                <td className="p-2">
                                                    <div className="">{supplier?.contactPerson?.name}</div>
                                                    { supplier?.contactPerson?.phone && <p className="mb-0 text-gray-400 text-xs italic">{ supplier?.contactPerson?.phone }</p> }
                                                </td>
                                                <td className="p-2">
                                                    <div className="text-center">{ supplier?.phones.join(', ') }</div>
                                                </td>
                                                <td className="p-2">
                                                    <div className="text-center">{ supplier?.emails.join(', ') }</div>
                                                </td>
                                                <td className="p-2 text-center">
                                                    <Link to={`/app/accounts/purchases/suppliers/${supplier._id}`}>
                                                        <button className="text-white hisani-btn-orange-light font-medium ml-2 rounded-lg text-sm px-3 py-1.5 text-center">View</button>
                                                    </Link>
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                            :
                            <div className="w-full h-16 flex items-center justify-center">
                                <p className="font-semibold text-base">Please click above to add a new supplier</p>
                            </div>
                    }
                </Receive>
                {Paginate}
            </div>
            <Switch>
                <Route path="/app/accounts/purchases/suppliers/new">
                    <NewSupplier onClose={refetch} path="/app/accounts/purchases/suppliers" />
                </Route>
                <Route path="/app/accounts/purchases/suppliers/:sid">
                    <Supplier onPerform={ fetch } path="/app/accounts/purchases/suppliers" />
                </Route>
            </Switch>
        </div>
    )
}

export default Suppliers